import React from "react";
import { cn } from "@/lib/utils";

export function FiresideCallout({ children, className }: { children: React.ReactNode; className?: string }) {
  return (
    <div className={cn("border-l-2 border-ember pl-6 py-2 my-8 font-serif italic text-ink-2", className)}>
      {children}
    </div>
  );
}

export function RightsCard({ title, sourceLoc, description, mechanism }: { title: string; sourceLoc: string; description: string; mechanism: string }) {
  return (
    <div className="flex flex-col border border-hairline p-8 bg-paper-2 hover:bg-paper transition-colors duration-300">
      <div className="font-mono text-[10px] font-bold text-ink-3 uppercase tracking-widest mb-3">
        {sourceLoc}
      </div>
      <h3 className="font-sans text-2xl font-medium text-ink mb-4">{title}</h3>
      <p className="text-sm text-ink-2 leading-relaxed mb-6 flex-1">
        {description}
      </p>
      <div className="pt-4 border-t border-hairline">
        <span className="font-mono text-[10px] font-bold text-ink-3 uppercase tracking-widest block mb-2">Mechanism</span>
        <p className="text-xs text-ink flex items-baseline gap-2">
          {mechanism}
        </p>
      </div>
    </div>
  );
}
